import { render } from "./ActAcceptanceView.vue?vue&type=template&id=1450e090&scoped=true"
import script from "./ActAcceptanceView.vue?vue&type=script&lang=js"
export * from "./ActAcceptanceView.vue?vue&type=script&lang=js"

import "./ActAcceptanceView.vue?vue&type=style&index=0&id=1450e090&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1450e090"]])

export default __exports__